import styled from 'styled-components';

import { Color, colors } from 'theme/theme';

export const AvatarContainer = styled.div<{ $border?: Color }>`
  border: 1px solid
    ${(props) => (props.$border ? colors[props.$border] : 'transparent')};
  border-radius: 100%;
  display: flex;
  width: max-content;
`;
